// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/campaign-builder'

const BaseCampaignBuilderAreaRoutes = {
  route: baseRoute,
  CampaignManagement: {
    route: '/campaign-management',
  },
  NewCampaign: {
    route: '/new-campaign',
  },
  InspectCampaign: {
    route: '/inspect-campaign',
    Approvals: {
      route: '/approvals',
    },
    AuditHistory: {
      route: '/audit-history',
    },
  },
}

const transformed = transformRoutes(BaseCampaignBuilderAreaRoutes)

export const CampaignBuilderAreaRoutes = {
  ...transformed,
  CampaignManagement: {
    ...transformed.CampaignManagement,
    path: 'campaign-management',
  },
  NewCampaign: {
    ...transformed.NewCampaign,
    path: 'new-campaign',
  },
  InspectCampaign: {
    ...transformed.InspectCampaign,
    path: 'inspect-campaign/*',
    Approvals: {
      ...transformed.InspectCampaign.Approvals,
      path: 'approvals',
    },
    AuditHistory: {
      ...transformed.InspectCampaign.AuditHistory,
      path: 'audit-history',
    },
  },
}
